import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Ui::Button::IconOnly\n  @icon={{this.displayedIcon}}\n  {{on \'click\' (fn-or-noop @onToggle)}}\n  class=\'pinmarker\'\n/>")